module.exports = __webpack_public_path__ + "img/9788959762132.1ef71172.jpg";